export class WebRTCPreview {
  constructor(
    public clientId: string,
    public brodcasterId: string,
    public availabilityZoneUrls: Array<string>,
    public tcpOnlyWebRTC: boolean = false,
  ) {}
}
